# TODO: brittany 10/4 - Stale b/c ratings?

$(->
  $(document).on 'click', '.rating-field a', (ev)->
    ev.preventDefault()
    return if $(this).closest('.rating-field').hasClass('disabled')
    the_input = $(this).closest('.rating-field').find('input')
    $(this).siblings('a').removeClass('selected')
    if $(this).hasClass('selected')
      $(this).removeClass('selected')
      the_input.val('')
    else
      $(this).closest('.rating-field').find('a').removeClass('selected')
      $(this).addClass('selected')
      $(this).prevAll('a').addClass('selected') if $(this).data('value') > 0
      the_input.val($(this).data('value'))

  $(document).on 'mouseover', '.rating-field a', ->
    return if $(this).data('value') < 1
    $(this).prevAll('a').addClass('hovered')
    $(this).nextAll('a').removeClass('hovered')
  $(document).on 'mouseout', '.rating-field a', ->
    $(this).siblings('a').removeClass('hovered')
)
